export default __webpack_public_path__ + "images/eaac00ef7c3ff6ec4d55bc3df1c6045f-Daybreaker_mobile_659x494.jpg";